import _ from "lodash";

export default (state: any[] = [], action: any) => {
	switch (action.type) {
		case "GET_SIGNER_SUCCESS":
		case "POST_SIGNER_SIGN_SUCCESS":
		case "POST_SIGNER_DECLINE_SUCCESS":
			return _.unionBy([action.resource], state, "id");
		case "GET_SIGNERS_SUCCESS":
			return _.unionBy(action.resource as any[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
